import { render, staticRenderFns } from "./mg-column-config.vue?vue&type=template&id=1033820f&scoped=true"
import script from "./mg-column-config.vue?vue&type=script&lang=js"
export * from "./mg-column-config.vue?vue&type=script&lang=js"
import style0 from "./mg-column-config.vue?vue&type=style&index=0&id=1033820f&prod&lang=scss&scoped=true"
import style1 from "./mg-column-config.vue?vue&type=style&index=1&id=1033820f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1033820f",
  null
  
)

export default component.exports